import StyledSwitch from "@/components/ui/customs/StyledSwitch";
import TaskIcon from "@/assets/icons/task.svg?react";
import { useForm } from "react-hook-form";
import {
  ParametersDapFormData,
  ParametersDapSchema,
} from "@/types/forms/bo/clientsParameters.form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

type ParametersDapProps = {
  optionDAPActive: boolean;
  handleUpdate: (data: ParametersDapFormData) => void;
};

export const ParameterDap = ({ optionDAPActive, handleUpdate }: ParametersDapProps) => {
  const { t } = useTranslation("boClients");
  const parametersDapForm = useForm<ParametersDapFormData>({
    resolver: zodResolver(ParametersDapSchema),
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      optionDAPActive: optionDAPActive || false,
    },
  });

  useEffect(() => {
    parametersDapForm.reset({
      optionDAPActive: optionDAPActive,
    });
  }, [optionDAPActive, parametersDapForm]);

  const optionDAPActiveWatch = parametersDapForm.watch("optionDAPActive");

  useEffect(() => {
    if (optionDAPActiveWatch !== optionDAPActive) {
      handleUpdate({
        optionDAPActive: optionDAPActiveWatch,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionDAPActiveWatch]);

  return (
    <div className="flex w-full max-w-[600px] flex-row gap-4 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-row items-center justify-between gap-4">
        <TaskIcon className="text-black" width={24} height={24} />
        <div className="flex flex-1 flex-col">
          <h3 className="text-lg font-semibold text-black">{t("dapOption.title")}</h3>
          <p className="text-sm text-gray-600">{t("dapOption.description")}</p>
        </div>
        <StyledSwitch control={parametersDapForm.control} name="optionDAPActive" />
      </div>
    </div>
  );
};
